import { QAndA, QAndAArgs, getQAndA } from '../assets/ts/data/q-and-a'
import useServerData from './use-server-data'

function useQandA(fetchArgs, waitOnParentDependency = false) {
  const {
    data: qAndA,
    error: qAndAError,
    fetchData: fetchQAndA,
    isLoading: qAndAIsLoading,
  } = useServerData<QAndA, QAndAArgs>(
    getQAndA,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchQAndA,
    qAndA,
    qAndAError,
    qAndAIsLoading,
  }
}

export default useQandA
